// Exact role-name checks for the web apps (mirinae-mono#9). The mirror of
// src/servers/front-end/src/modules/roles.js, which carries the full reasoning: the checks these
// replace were unanchored regexes, so any role merely *containing* a staff name passed -- the
// university roles among them. Keep the two files in step.
//
// Only what the converted call sites need so far. The browser's remaining checks decide which
// buttons to draw, and the server refuses the request either way, so they are being converted
// separately. The checks here are different: they decide whose name a post is shown under.

export const STAFF = ['admin', 'superadmin'];

// written by mirinae staff -- decides whether a post appears as the official Mirinae account
export const isStaff = (user) => STAFF.includes(user?.role);

// setting schools up (#19) -- the server's isSuperAdmin; this only decides whether the menu shows
export const isSuperAdmin = (user) => user?.role === 'superadmin';

// a distributor, who signs schools up for Mirinae (#76) -- the server's isDistributor; in no staff list
export const isDistributor = (user) => user?.role === 'distributor';

// Any internal role, i.e. everyone who gets Pro features without paying. This is exactly the set
// the old /admin|super|lesson/ regex admitted: the lesson roles are here because 'lesson' matched
// them, and dropping one would take Pro away from people who have it today. Whether a lesson tester
// should get Pro is a separate question from anchoring the check.
const INTERNAL_ROLES = [...STAFF, 'superuser', 'lessoneditor', 'lessoncreator', 'lessontester'];
export const isInternalRole = (user) => INTERNAL_ROLES.includes(user?.role);
